"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaskedPhoneNumberInputSchema = void 0;
exports.default = MaskedPhoneNumberInput;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const zod_1 = require("zod");
const material_1 = require("@mui/material");
const react_hook_form_1 = require("react-hook-form");
exports.MaskedPhoneNumberInputSchema = ((options) => {
    return {
        options,
        create: (fieldName, validation) => {
            return zod_1.z.object({ [fieldName]: validation });
        },
    };
})({
    // validations:
    default: zod_1.z.coerce.string().regex(/^\(\d{3}\) \d{3}-\d{4}$/, 'Valid Phone Number Required'),
});
const formatPhoneNumber = (val) => {
    const digits = val.replace(/[^\d]/g, '');
    if (digits.length < 1)
        return '';
    if (digits.length < 4) {
        return `(${digits}`;
    }
    if (digits.length < 7) {
        return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    }
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
};
function MaskedPhoneNumberInput(_a) {
    var { label, name } = _a, props = __rest(_a, ["label", "name"]);
    const [initialFormatting, setInitialFormatting] = (0, react_1.useState)(false);
    const { control, setValue } = (0, react_hook_form_1.useFormContext)();
    const { field, formState: { errors }, } = (0, react_hook_form_1.useController)({ name, control });
    const error = errors[name];
    field.value = formatPhoneNumber(field.value);
    (0, react_1.useEffect)(() => {
        if (!initialFormatting) {
            setValue(name, formatPhoneNumber(field.value));
            setInitialFormatting(true);
        }
    }, [initialFormatting, setValue, name, field.value]);
    return ((0, jsx_runtime_1.jsx)(material_1.TextField, Object.assign({ label: label, error: Boolean(error), helperText: error === null || error === void 0 ? void 0 : error.message, placeholder: "(XXX) XXX-XXXX" }, field, { onChange: (e) => {
            const formatted = formatPhoneNumber(e.target.value);
            field.onChange(formatted);
        }, required: true }, props)));
}
//# sourceMappingURL=MaskedPhoneNumberInput.js.map